/**
 * Header the backend monorepo routes on when serving a git worktree app on the local stack.
 */
export const WORKTREE_HEADER = 'X-Worktree';
